import { render, staticRenderFns } from "./Marketers.vue?vue&type=template&id=d4a1c804"
import script from "./Marketers.vue?vue&type=script&lang=js"
export * from "./Marketers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports